import { assert } from "@/core";
import { BaseService } from "./base.service";
import { ResponseWrapper } from "./util";

export class DoctorTimeSlotService extends BaseService {
  static get entity() {
    return "doctor-time-slots";
  }

  static async getList(parameters = {}) {
    assert.object(parameters);

    const params = { ...parameters };

    const response = await this.request({ auth: true }).get(
      `/sync/kiosk/doctor-time-slots`,
      { params },
    );

    return new ResponseWrapper(response, response.data.data);
  }

  static async getByDoctorId(parameters = {}) {
    assert.object(parameters);

    const params = { ...parameters };

    const response = await this.request({ auth: true }).get(
      `/sync/hospital-staff/date-selection/doctor-time-slots`,
      { params },
    );

    return new ResponseWrapper(response, response.data.data);
  }

  static async assignTimeslots(params = {}, payload = {}) {
    assert.object(params);
    assert.object(payload);

    try {
      const response = await this.request({ auth: true }).post(
        `/sync/doctor-time-slots/assign-timeslots`,
        payload,
        { params },
      );
      return new ResponseWrapper(response, response);
    } catch (error) {
      throw this.errorWrapper(error);
    }
  }

  static async getSlotsV2(parameters = {}) {
    assert.object(parameters);
    const params = { ...parameters };
    try {
      const response = await this.request({ auth: true }).get(
        `/sync/v2/doctor-time-slots/time-slots-by-day`,
        { params },
      );
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw this.errorWrapper(error);
    }
  }

  static async update(slotId, payload) {
    assert.string(slotId);
    assert.object(payload);
    try {
      const response = await this.request({ auth: true }).patch(
        `/sync/v2/doctor-time-slots`,
        payload,
        { params: { slotId } },
      );
      return new ResponseWrapper(response, response);
    } catch (error) {
      throw this.errorWrapper(error);
    }
  }

  static async delete(slotId, appointmentType) {
    assert.string(slotId);
    assert.string(appointmentType);
    try {
      const response = await this.request({ auth: true }).delete(
        `/sync/v2/doctor-time-slots`,
        {
          params: {
            slotId,
            appointmentType,
          },
        },
      );

      return new ResponseWrapper(response, response);
    } catch (error) {
      throw this.errorWrapper(error);
    }
  }

  static async updateSittingDates(payload = {}) {
    assert.object(payload);
    try {
      const response = await this.request({ auth: true }).patch(
        `/sync/doctor-time-slots/v2/sittingDates`,
        payload,
      );
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw this.errorWrapper(error);
    }
  }

  static async getSittingDates(parameters = {}) {
    assert.object(parameters);
    const params = { ...parameters };
    const response = await this.request({ auth: true }).get(
      `/sync/doctor-time-slots/v2/sittingDates`,
      { params },
    );
    // Note: User's example shows a nested data structure
    return new ResponseWrapper(response, response.data.data);
  }

  static async getTimeslotsV2(parameters = {}) {
    assert.object(parameters);
    const params = { ...parameters };
    const response = await this.request({ auth: true }).get(
      `/sync/v2/doctor-time-slots`,
      { params },
    );
    return new ResponseWrapper(response, response.data.data);
  }

  /**
   * Update doctor slots with selected timeslots
   * @param {Object} payload - Contains slots (array of slot IDs), doctorId, and appointmentTypeIds
   * @returns {Promise<ResponseWrapper>}
   */
  static async updateDoctorSlots(payload = {}) {
    assert.object(payload);
    try {
      const response = await this.request({ auth: true }).post(
        `/sync/v2/doctor-time-slots/update-doctor-slots`,
        payload,
      );
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw this.errorWrapper(error);
    }
  }
}
